import { useTranslation } from "react-i18next";
import {
	FrontendCompanyWithAdditionalInfomation,
	FrontendUserInfo,
} from "node-library/dist/portal";
import { OrderTableSortColumn, SortOrder } from "node-library/dist/paginations";
import { NeutralColor } from "node-library/dist/colors";
import { useEffect, useState } from "react";
import { FrontendContentPage } from "node-library/dist/constants";
import { FrontendSampleTestBatchOverview } from "node-library/dist/structures/frontendSampleTestBatchPageDefinitions";
import AnalystViewBatchTableListView from "./analystViewBatchTableListView";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;

	batchOverviews: Array<FrontendSampleTestBatchOverview>;
	user: FrontendUserInfo | undefined;
	// sortBy: OrderTableSortColumn;
	// setSortBy: React.Dispatch<React.SetStateAction<OrderTableSortColumn>>;
	// sortOrder: SortOrder;
	// setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;

	navigateToBatchDetailsPage: (
		batchId: string,
		fromPage: FrontendContentPage
	) => void;
}

export default function AnalystViewBatchContent(props: Props) {
	const { t: translation } = useTranslation();

	const {
		company,
		batchOverviews,
		// sortBy,
		// setSortBy,
		// sortOrder,
		// setSortOrder,
		navigateToBatchDetailsPage,
	} = props;

	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 600);
		};

		// Set the initial screen size on mount
		handleResize();

		// Listen for window resize
		window.addEventListener("resize", handleResize);

		// Clean up the event listener
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return (
		<div style={{ flex: "1 1 0%", position: "relative" }}>
			{batchOverviews.length === 0 ? (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%, -50%)",
						gap: "5px",
					}}
				>
					<div className="no-order-icon"></div>

					<div
						className="typography-body-01 typography-bold"
						style={{ marginTop: "20px" }}
					>
						{translation("NoBatches")}
					</div>
					<div
						className="typography-body-02"
						style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
					>
						{translation("NoBatchesDescription")}
					</div>
				</div>
			) : (
				// isMobile ? (
				// 	// <AnalystViewOrdersTableGridView
				// 	// 	orders={orders}
				// 	// 	user={props.user}
				// 	// 	deleteOrder={deleteOrder}
				// 	// 	viewOrderCOC={viewOrderCOC}
				// 	// 	goToViewOrderDetails={goToViewOrderDetails}
				// 	// 	setDiscardOrderConfirmOpen={setDiscardOrderConfirmOpen}
				// 	// 	setProceedAction={setProceedAction}
				// 	// />
				// 	<></>
				// ) : (
				// 	<AnalystViewBatchTableListView
				// 		company={company}
				// 		batchOverviews={batchOverviews}
				// 		user={props.user}
				// 		navigateToOrderDetailsPage={navigateToOrderDetailsPage}
				// 		navigateToBatchDetailsPage={navigateToBatchDetailsPage}
				// 	/>
				// )
				<AnalystViewBatchTableListView
					company={company}
					batchOverviews={batchOverviews}
					user={props.user}
					navigateToBatchDetailsPage={navigateToBatchDetailsPage}
				/>
			)}
		</div>
	);
}
